"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringArrayEncoding = void 0;
const tsenum_1 = require("@gradecam/tsenum");
exports.StringArrayEncoding = tsenum_1.MakeEnum({
    None: 'none',
    Base64: 'base64',
    Rc4: 'rc4'
});
